import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';
import useApiUrl from '../framework/hooks/useApiUrlHook';

export default function Brands() {
    const apiUrl = useApiUrl();
    const [brands, setBrands] = useState([]);

    const getBrands = () => {
        axios
            .get(`${apiUrl}/brands/all`)
            .then((response) => {
                setBrands(response.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    useEffect(() => {
        if (apiUrl != null) getBrands();
    }, [apiUrl]);

    return (
        <div className="brand-area sections section-b">
            <div className="brand-wrapper">
                <div className="brand-title" data-aos="fade-up" data-aos-delay={300} data-aos-duration={1000}>
                    <h2>Hier zijn wij trots op</h2>
                    <h3>Je bent in goed gezelschap</h3>
                </div>
                <div className="brand-layout" data-aos="fade-up" data-aos-delay={400} data-aos-duration={1000}>
                    {brands?.map((brand) => (
                        <a key={brand.id} href={`/succesverhalen/${brand.url}`} className="brand-item">
                            <img
                                src={`${apiUrl}/img/extern/ratio/www.bandwerk.nl/klanten_logo/orig/220/128/100/${brand.image}`}
                                alt={brand.klant}
                            />
                        </a>
                    ))}
                </div>
            </div>
        </div>
    );
}
